import * as yup from "yup";
import "yup-phone-lite";

export const validationsVerifyAuthCodeSchema = yup.object({
  authCode: yup.string()
    .min(14, "The auth code must contain at 14 characters")
    .max(14, "The auth code must contain at 14 characters")
    .required("Enter your auth code"),
  cwdAuthCode: yup
    .string()
    .oneOf([yup.ref("authCode")], "Auth code does not match")
    .required("Confirm your auth code"),
})

export const validationsSignInSchema = yup.object({
  email: yup.string()
    .email("Enter a valid email")
    .required("Email is required"),
  password: yup.string()
    .min(8, "Password must contain at least 8 characters")
    .required("Password is required")
})

export const validationsSignUpSchema = yup.object({
  email: yup.string()
    .email("Enter a valid email")
    .required("Email is required"),
  password: yup.string()
    .min(8, "Password must contain at least 8 characters")
    .required("Password is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "Password does not match")
    .required("Confirm your password"),
})

export const validationsUserInfoSchema = yup.object({
  firstName: yup.string().required("Required first name"),
  lastName: yup.string().required("Required last name"),
  phone: yup.string().nullable().phone().required("Required phone"),
  npi: yup.string().required("Required npi")
})

export const validationsUserSubjectSchema = yup.object({
  title: yup.string(),
  specify: yup.string(),
  bio: yup.string()
    .max(300, "Max is 300"),
})

export const validationsClinicSchema = yup.object({
  clinicAddressLine1: yup.string().required("Required clinic address"),
  clinicName: yup.string(),
  clinicAddressCity: yup.string().required("Required"),
  clinicAddressState: yup.string().required("Required"),
  clinicAddressPostalCode: yup.string().required("Required")
})

export const validationsProfileEditFormSchema = yup.object({
  phone: yup.string().nullable().phone().required("Required phone"),
  npi: yup.string().nullable().required("Required npi"),
  title: yup.string().nullable(),
  specialty: yup.string().nullable(),
  bio: yup.string().max(300, "Max is 300").nullable(),
  clinicAddressLine1: yup.string().nullable().required("Required clinic address"),
  clinicName: yup.string().nullable(),
  clinicAddressCity: yup.string().nullable().required("Required"),
  clinicAddressState: yup.string().nullable().required("Required"),
  clinicAddressPostalCode: yup.string().nullable().required("Required")
})

export const validationsPatientDetailEditFormSchema = yup.object({
  email: yup.string()
    .email("Enter a valid email")
    .required("Email is required"),
  firstName: yup.string().required("Required"),
  lastName: yup.string().required("Required"),
  phone: yup.string().phone().required("Required phone"),
  birthMonth: yup.string().required("Required"),
  birthDate: yup.string().required("Required"),
  birthYear: yup.string().required("Required")
})

export const validationsResetPasswordSchema = yup.object({
  password: yup.string()
    .min(8, "Password must contain at least 8 characters")
    .required("Enter your password"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "Password does not match")
    .required("Confirm your password"),
})

export const validationsUpdatePasswordSchema = yup.object({
  password: yup.string()
    .min(8, "Password must contain at least 8 characters")
    .required("Enter your current password"),
  newPassword: yup.string()
    .min(8, "Password must contain at least 8 characters")
    .required("Enter your new password"),
  confirmNewPassword: yup
    .string()
    .oneOf([yup.ref("newPassword")], "New password does not match")
    .required("Confirm your new password"),
})
